import { Checkbox } from '@pickleballinc/ui/components/ui/checkbox';
import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@pickleballinc/ui/components/ui/tooltip';
import { Controller, useFormContext } from 'react-hook-form';

interface CheckboxFormProps {
	name: string;
	label: string;
	isDisabled?: boolean;
	/** When set, the row shows an explanatory tooltip on hover */
	tooltip?: string;
}

export default function CheckboxForm({ name, label, isDisabled = false, tooltip }: CheckboxFormProps) {
	const { control } = useFormContext();

	const row = (
		<div className="flex gap-2 items-center">
			<Controller
				control={control}
				name={name}
				defaultValue={false}
				render={({ field }) => (
					<Checkbox
						{...field}
						className="size-5 rounded-md data-[state=checked]:bg-primary-100 data-[state=checked]:text-primary"
						id={name}
						disabled={isDisabled}
						checked={field.value}
						onCheckedChange={(checked: boolean) => {
							field.onChange(checked);
						}}
					/>
				)}
			/>
			<p className="text-base font-medium text-gray-900 cursor-default">{label}</p>
		</div>
	);

	if (!tooltip) return row;

	return (
		<TooltipProvider delayDuration={0} skipDelayDuration={0}>
			<Tooltip>
				<TooltipTrigger asChild>{row}</TooltipTrigger>
				<TooltipPortal>
					<TooltipContent className="bg-gray-900">
						<p>{tooltip}</p>
					</TooltipContent>
				</TooltipPortal>
			</Tooltip>
		</TooltipProvider>
	);
}
